export default {
    "DeFi Binance": "DeFi Binance",
    "流动性挖矿": "Liquidity Mining",
    "加入节点， 开始挖矿": "Join Node, Start Mining",
    "参 与": "Participate",
    "矿池数据": "Pool Data",
    "总产量": "Total Output",
    "有效节点": "Active Nodes",
    "参与者": "Participants",
    "用户收入": "User Income",
    "挖矿榜单": "Mining Leaderboard",
    "流动性挖矿收入": "Liquidity Mining Income",
    "输出记录": "Output Records",
    "地址": "Address",
    "数量": "Amount",
    "帮助中心": "Help Center",
    "希望它可以帮助你": "Hope It Helps You",
    "安全保障": "Security Assurance",
    "我们有安全的审计报告": "Audited Security Reports",
    "伙伴": "Partners",
    "我们的商业伙伴": "Our Business Partners",
    "首页": "Home",
    "我的矿池": "My Pool",
    "提取": "Withdraw",
    "账户": "Account",
    "总挖矿金额": "Total Mining Amount",
    "可更换": "Exchangeable",
    "收益率": "Yield",
    "币池名称": "Pool Name",
    "最低金额": "Minimum Amount",
    "收益率/24小时": "Yield/24h",
    "挖矿记录": "Mining Records",
    "金额": "Amount",
    "描述": "Description",
    "时间": "Time",
    "已参与": "Joined",
    "质 押": "Stake",
    "已质押": "Staked",
    "记录": "Record",
    "兑换": "Exchange",
    "从": "From",
    "全部": "All",
    "至": "To",
    "价格": "Price",
    "确认": "Confirm",
    "矿池收益": "Pool Earnings",
    "今日收益": "Today's Earnings",
    "普通矿池": "Standard Pool",
    "高级矿池": "Advanced Pool",
    "全部的": "All",
    "可用的": "Available",
    "申请加入": "Apply to Join",
    "推荐朋友": "Refer Friends",
    "一起赚取加密货币": "Earn Crypto Together",
    "查看详情": "View Details",
    "团队": "Team",
    "推荐": "Referral",
    "团队规模": "Team Size",
    "直接发起人": "Direct Referrers",
    "总收入": "Total Income",
    "今天的收入": "Today's Income",
    "我的推荐链接": "My Referral Link",
    "复制": "Copy",
    "1. 获取链接": "1. Get Link",
    "2. 邀请朋友": "2. Invite Friends",
    "3. 赚取加密货币": "3. Earn Crypto",
    "等级": "Level",
    "1 级": "Level 1",
    "2 级": "Level 2",
    "3 级": "Level 3",
    "用户地址": "User Address",
    "币种": "Token",
    "说明": "Details",
    "状态": "Status",
    "定时收益": "Scheduled Earnings",
    "今日预收益": "Today's Estimated Earnings",
    "累计收益": "Total Earnings",
    "将矿池收益的BNB兑换成USDT后立即到账": "Convert Pool Earnings to USDT Instantly",
    "将USDT提取后会在24小时内到达你的钱包": "Withdraw USDT to Wallet Within 24h",
    "天": "Days",
    "高级矿池收益": "Advanced Pool Earnings",
    "质押收益": "Staking Earnings",
    "下次收益": "Next Earnings",
    "当前收益率": "Current Yield",
    "昨日收益": "Yesterday's Earnings",
    "普通矿池收益率": "Standard Pool Yield",
    "高级矿池收益率": "Advanced Pool Yield",
    "高级矿池限时开放": "Advanced Pool Limited Time Only",
	"公告":"announcement",
	"我知道了":"OK"
};
